import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ThemeProvider } from '@/theme/ThemeProvider'
import { queryClient } from '@/lib/queryClient'
import { createAppRouter } from '@/router/routes'

const router = createAppRouter()

// 根组件：主题、数据请求缓存、路由
export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  )
}
